module.exports = __webpack_public_path__ + "static/media/background.a8a18eb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/TellMeMoreView/background.jpg
// module id = 996
// module chunks = 0